import { generateUtilityClasses } from '@mui/material';

// generateUtilityClasses가 이미 타입을 제공하므로 별도 인터페이스 불필요
export const datePickerClasses = generateUtilityClasses('DatePicker', [
  // Core
  'root',
  'input',
  'inputIcon',
  'timezone',

  // Calendar
  'popper',
  'container',
  'calendar',

  // Header
  'header',
  'navigationContainer',
  'prevMonthButton',
  'nextMonthButton',
  'monthYearDisplay',

  // Time
  'timePickerContainer',

  // Range
  'separator',
]);
